<template>
  <div class="feature">
    <div class="feature__content">
      <aside class="feature__tag text__small_content spacing__mb_3">
        {{ feature.tag }}
      </aside>
      <h2 class="text__header_2 text__accent">
        {{ feature.title }}
      </h2>
      <p class="text__subheader text__accent spacing__mt_4">
        {{ feature.text }}
      </p>
      <div class="feature__icon_list spacing__mt_3">
        <i
          v-for="(icon, index) in feature.iconList"
          :key="index"
          class="icon x24"
          :class="`icon_24_${icon}_blue`"
        ></i>
      </div>
    </div>
    <div class="feature__media">
      <video
        playsinline
        autoplay
        muted
        loop
        :alt="feature.title"
        style="width: 100%;"
        class="spacing__mt_6"
        :class="applyFix(feature.mediaResource)"
      >
        <source :src="feature.mediaResource" type="video/webm" />
        <source :src="feature.mediaAlternative" type="video/mp4" />
        {{ $t('video_no_support') }}
      </video>
    </div>
  </div>
</template>

<script>
import { Feature } from '../model/Feature'

export default {
  name: 'FeatureItem',
  props: {
    feature: {
      type: Feature,
      default: null,
    },
  },
  methods: {
    applyFix(image) {
      if (image.includes('asset-3')) return 'fix__gif2'
      else if (image.includes('asset-4')) return 'fix__gif3'
      return ''
    },
  },
}
</script>

<style lang="scss" scoped>
.feature {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, calc(50% - 52px));
  column-gap: 104px;
  box-sizing: border-box;

  &__media {
    width: 100%;
  }

  &__tag {
    text-align: center;
    align-self: flex-start;
    width: 80px;
    color: #ffffff;
    background: #d79629;
    border-radius: 2px;
  }

  &__icon_list {
    display: flex;

    & i {
      margin-right: 64px;
    }
  }
}

.fix__gif2,
.fix__gif3 {
  object-fit: contain;
  object-position: -1px;
}

.fix__gif3 {
  object-position: 2px;
}

@media only screen and (max-width: 768px) {
  .feature {
    display: flex;
    grid-template-columns: unset;
    column-gap: unset;
    flex-flow: column;

    &__content {
      padding: 0 24px !important;

      & h2 {
        font-size: 24px;
        line-height: 30px;
      }

      & p {
        font-size: 16px;
        line-height: 26px;
      }
    }

    &__icon_list {
      justify-content: space-around;

      & i {
        margin-right: 0;
      }
    }
  }
}
</style>
